import { render, staticRenderFns } from "./SortingItem.vue?vue&type=template&id=c1949c2a&scoped=true"
import script from "./SortingItem.vue?vue&type=script&lang=js"
export * from "./SortingItem.vue?vue&type=script&lang=js"
import style0 from "./SortingItem.vue?vue&type=style&index=0&id=c1949c2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1949c2a",
  null
  
)

export default component.exports